import { ThisConnector } from '../connector'

export interface OrganizationFeatureArgs {
  organizationUuid: string
  featureId: string
}

export interface OrganizationFeatureResponse {
  enabled: boolean
}

export async function getOrganizationFeature(
  this: ThisConnector,
  { organizationUuid, featureId }: OrganizationFeatureArgs
): Promise<OrganizationFeatureResponse> {
  const { enabled } = await this.connector.get(
    `${organizationUuid}/feature/${featureId}`
  )

  return { enabled }
}
